<!-- Wrapper -->
<div 
[class.has-menu]="hasMenu"
[class.no-menu]="!hasMenu"
class="hk-wrapper" 
data-layout="horizontal" 
data-layout-style="default" 
data-menu="light" 
data-footer="simple"
>
  <app-header></app-header>
  <app-alerts></app-alerts>
  <div class="hk-menu" *ngIf="hasMenu">
    <ng-content select="[menu]"></ng-content>
  </div>


  <!-- CONTENT SLOT -->
  <ng-content select="[content]"></ng-content>

  <app-footer></app-footer>

</div>

<!-- Keep global floating surfaces outside the legacy wrapper stacking context. -->
<app-realtime-toasts></app-realtime-toasts>
<app-chat></app-chat>
<app-ai-chat></app-ai-chat>
